import image1 from "../assets/t-image1.jpg";
import image2 from "../assets/t-image2.jpg";
import image3 from "../assets/t-image3.jpg";

export const testimonialsData = [
  {
    image: image1,
    review:
      "I made the right choice by choosing the Hunk Fitness Studio and by choosing the right plan and program I already achieved my ideal body!",
    name: 'Vishva N R',
    status : 'ENTREPRENEUR'
  },
  {
    image: image2,
    review: 'I’m an experienced personal trainer and fitness enthusiast who specializes in helping people to reach their weight-loss goals.',
    name: 'Varun R',
    status: 'COACH'
  },
  {
    image : image3,
    review:'I’ve always been physically active, but I decided to begin weight training with a personal trainer a little over a year ago and the results have been amazing.',
    name: 'Yokesh R',
    status: "CUSTOMER"
  }
];
